import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>Privacy Policy for True Weather</h1>
        
      <h2>Introduction</h2>
      <p>
        True Weather ("we," "us," or "our") values your privacy and is committed to protecting it. 
        This Privacy Policy explains how we collect, use, and share information when you use the True Weather app. 
        By using the app, you agree to the terms outlined in this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        True Weather is designed to prioritize your privacy and does not collect sensitive or personal data such as live 
        location or identifiable information.
      </p>
      <ul>
        <li>
          <strong>Usage Data:</strong> We may collect anonymous data on how you interact with the app, such as the features 
          you use and the frequency of usage. This data helps us improve the app's performance and functionality.
        </li>
        <li>
          <strong>Device Information:</strong> We may collect information about your device, such as the operating system, 
          app version, and device model, to ensure compatibility and enhance the user experience.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        The information we collect is used to:
      </p>
      <ul>
        <li>Improve the app’s functionality and user experience.</li>
        <li>Monitor and analyze app performance for troubleshooting and updates.</li>
      </ul>
      <p>We do not use your data for any marketing purposes or share it with third parties for advertising.</p>

      <h2>3. Sharing Your Information</h2>
      <p>
        We do not share your personal data with third parties except:
      </p>
      <ul>
        <li>When required by law to comply with legal obligations or respond to lawful requests by public authorities.</li>
        <li>
          With trusted service providers who assist us in app analytics and maintenance. These providers are bound by strict 
          confidentiality agreements.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement industry-standard measures to protect the data collected through our app. However, no method of 
        transmission over the internet is completely secure, and we cannot guarantee absolute security.
      </p>

      <h2>5. Children’s Privacy</h2>
      <p>
        True Weather is not intended for use by children under the age of 13. We do not knowingly collect any information 
        from children. If we become aware of data collected from children, we will take steps to delete it immediately.
      </p>

      <h2>6. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any 
        updates will be posted on this page, and the "Effective Date" will be revised. Please review this policy regularly.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy or the data practices of True Weather, please 
        contact us at:
      </p>
      <p>
        dheenadhayalanPerumal@gmail.com <br />
      </p>

      <p><strong>Enjoy True Weather with the confidence that your privacy is protected.</strong></p>
    </div>
  );
};

export default PrivacyPolicy;
